const COOKIE_KEY = 'seen_tours';
const ONE_YEAR = 60 * 60 * 24 * 365;

function readCookie(name: string): string | null {
  if (typeof document === 'undefined') return null;

  const match = document.cookie.split('; ').find((row) => row.startsWith(`${name}=`));

  return match ? match.split('=')[1] : null;
}

export function getSeenTours(): string[] {
  const raw = readCookie(COOKIE_KEY);
  if (!raw) return [];

  try {
    const parsed = JSON.parse(decodeURIComponent(raw));
    return Array.isArray(parsed) ? parsed.map(String) : [];
  } catch {
    return [];
  }
}

export function addSeenTour(tourId: string) {
  if (typeof document === 'undefined') return;

  const tours = getSeenTours();

  if (tours.includes(tourId)) return;

  const next = [...tours, tourId];

  document.cookie = [
    `${COOKIE_KEY}=${encodeURIComponent(JSON.stringify(next))}`,
    'path=/',
    `max-age=${ONE_YEAR}`,
    'SameSite=Lax',
  ].join('; ');
}
